import { useNavigate } from 'react-router-dom'
import { NavigationOptions } from '../interfaces/NavigationOptions'

const useNavigation = () => {
   const navigate = useNavigate()

   const navigateTo = (path: string, options?: NavigationOptions) => {
      const defaultOptions: NavigationOptions = { replace: true }
      navigate(path, { ...defaultOptions, ...options })
   }

   return { navigateTo }
}

export default useNavigation
